import { ReactNode, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Icons from './Icons';

interface MenuListItemProps {
  text: string;
  customOnClick?: () => void;
  linkPath?: string;
  icon?: ReactNode;
  additionalElement?: ReactNode;
  exactMatch?: boolean;
  childrenItems?: MenuListItemProps[];
  controlClassName?: string;
}

export const MenuListItem = (props: MenuListItemProps) => {
  const {
    controlClassName,
    text,
    linkPath,
    icon,
    additionalElement,
    customOnClick,
    exactMatch,
    childrenItems,
  } = props;

  const location = useLocation();
  const navigate = useNavigate();
  const onClick =
    customOnClick ?? (linkPath ? () => navigate(linkPath) : undefined);
  const [isExpanded, setIsExpanded] = useState<boolean>(
    !!childrenItems?.some(e =>
      isActive(location.pathname, e.linkPath, e.exactMatch),
    ),
  );

  // expandable item
  if (childrenItems?.length) {
    return (
      <>
        <li>
          <a onClick={() => setIsExpanded(!isExpanded)}>
            {icon && <span className="account-nav-icon">{icon}</span>}
            <span className="account-nav-item">{text}</span>
            {isExpanded ? (
              <div className="nav-expand-icon">
                <Icons.MNavUp />
              </div>
            ) : (
              <div className="nav-expand-icon">
                <Icons.MNavDown />
              </div>
            )}
          </a>
        </li>
        {isExpanded && (
          <>
            {childrenItems.map(e => (
              <MenuListItem key={e.text} {...e} />
            ))}
          </>
        )}
      </>
    );
  }

  // active item
  if (isActive(location.pathname, linkPath, exactMatch)) {
    return (
      <li className="active">
        <a onClick={() => onClick?.()} className={controlClassName}>
          {icon && <span className="account-nav-icon">{icon}</span>}
          <b className="account-nav-item">{text}</b>
          {additionalElement}
        </a>
      </li>
    );
  }

  // inactive item
  return (
    <li>
      <a onClick={() => onClick?.()} className={controlClassName}>
        {icon && <span className="account-nav-icon">{icon}</span>}
        <span className="account-nav-item">{text}</span>
        {additionalElement}
      </a>
    </li>
  );
};

const isActive = (
  locationPath: string,
  linkPath?: string,
  exactMatch?: boolean,
) => {
  if (!linkPath) return false;
  if (exactMatch && locationPath === linkPath) return true;
  if (!exactMatch && locationPath.includes(linkPath)) return true;
  return false;
};
